export default [
  {
    path: 'M0 0m184.32 0l655.36 0q184.32 0 184.32 184.32l0 655.36q0 184.32-184.32 184.32l-655.36 0q-184.32 0-184.32-184.32l0-655.36q0-184.32 184.32-184.32Z',
    fill: '#FFFFFF',
  },
  {
    path: 'M512 296.96a102.4 102.4 0 1 0 102.4 102.4 102.51264 102.51264 0 0 0-102.4-102.4m0-92.16a194.56 194.56 0 1 1-194.56 194.56 194.56 194.56 0 0 1 194.56-194.56z',
    fill: '#61C3FA',
  },
  {
    path: 'M822.36416 741.632a179.4048 179.4048 0 0 1-253.27616-8.83712 46.08 46.08 0 0 1 2.27328-65.1264 46.08 46.08 0 0 1 65.1264 2.27328 87.04 87.04 0 1 0 4.3008-123.02336 46.08 46.08 0 0 1-65.1264-2.27328 46.08 46.08 0 0 1 2.27328-65.1264 179.2 179.2 0 0 1 244.4288 262.11328zM317.44 522.24a92.16 92.16 0 1 0 92.16 92.16 92.2624 92.2624 0 0 0-92.16-92.16m0-92.16a184.32 184.32 0 1 1-184.32 184.32 184.32 184.32 0 0 1 184.32-184.32z',
    fill: '#61C3FA',
  },
  {
    path: 'M437.79072 753.96096l-65.83296-64.512 208.65024-213.01248 65.83296 64.512z',
    fill: '#61C3FA',
  },
  {
    path: 'M512 593.92a194.78528 194.78528 0 0 1-194.56-194.56 46.08 46.08 0 0 1 46.08-46.08 46.08 46.08 0 0 1 46.08 46.08 102.4 102.4 0 0 0 204.8 0 46.08 46.08 0 0 1 92.16 0 194.78528 194.78528 0 0 1-194.56 194.56z',
    fill: '#EC5A70',
  },
  {
    path: 'M378.88 942.08h133.12v81.92h-133.12a40.96 40.96 0 0 1-40.96-40.96 40.96 40.96 0 0 1 40.96-40.96z',
    fill: '#EB566F',
  },
  {
    path: 'M512 942.08h133.12a40.96 40.96 0 0 1 40.96 40.96 40.96 40.96 0 0 1-40.96 40.96h-133.12v-81.92z',
    fill: '#448BF7',
  },
]
